import React, { Component } from "react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withNamespaces } from 'react-i18next';

import { connect } from "react-redux";
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader
} from "../../store/actions";

class SidebarContent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userPerms:[],
        };
       
    }
    
    componentDidMount() {        
        this.initMenu();
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
          
            if (this.props.type !== prevProps.type) {
                this.initMenu();
            }

        }
    }

    initMenu() {
            new MetisMenu("#side-menu");

            var matchingMenuItem = null;
            var ul = document.getElementById("side-menu");
            var items = ul.getElementsByTagName("a");
            for (var i = 0; i < items.length; ++i) {
                if (this.props.location.pathname === items[i].pathname) {
                    matchingMenuItem = items[i];
                    break;
                }
            }
            if (matchingMenuItem) {
                this.activateParentDropdown(matchingMenuItem);
            }
    }

    activateParentDropdown = item => {
        item.classList.add("active");
        const parent = item.parentElement;

        if (parent) {
            parent.classList.add("mm-active");
            const parent2 = parent.parentElement;

            if (parent2) {
                parent2.classList.add("mm-show");

                const parent3 = parent2.parentElement;

                if (parent3) {
                    parent3.classList.add("mm-active"); // li
                    parent3.childNodes[0].classList.add("mm-active"); //a
                    const parent4 = parent3.parentElement;
                    if (parent4) {
                        parent4.classList.add("mm-active");
                    }
                }
            }
            return false;
        }
        return false;
    };

    render() {
        var Perm    =   localStorage.getItem("HasPerms") ? JSON.parse(localStorage.getItem("HasPerms")) : [];
        var userPerms = [];
        Perm.map((item,index)=>{            
            userPerms.push(item.permissions_id);
        })
        
        
        return (
            <React.Fragment>

                 <div id="sidebar-menu">

                        <ul className="metismenu list-unstyled" id="side-menu">                           

                            <li>
                                <Link to="/dashboard" className="waves-effect">
                                    <i className="fas fa-tachometer-alt"></i><span className="badge badge-pill badge-success float-right"></span>
                                    <span className="ml-1">{this.props.t('Dashboard')}</span>
                                </Link>
                            </li>  
                            
                            <li>
                                <Link to="/my-account" className="waves-effect">
                                    <i className="fa fa-user"></i><span className="badge badge-pill badge-success float-right"></span>
                                    <span className="ml-1">{this.props.t('My Account')}</span>
                                </Link>
                            </li>    
                            {
                                localStorage.getItem("user_type") === 'admin' ?
                                    <li>
                                        <Link to="/#" className="has-arrow waves-effect">
                                            <i className="fa fa-users"></i>
                                            <span className="ml-1">{this.props.t('Users')}</span>
                                        </Link>
                                        <ul className="sub-menu" aria-expanded="false">
                                            <li><Link to="/all-users">{this.props.t('All Users')}</Link></li>
                                            <li><Link to="/add-user">{this.props.t('Add User')}</Link></li>
                                        </ul>
                                    </li>  
                                : null
                            } 

                            {
                                userPerms.indexOf(1) !== -1  || localStorage.getItem("user_type") === 'admin' ?
                            
                                <li>
                                    <Link to="/#" className="has-arrow waves-effect">
                                        <i className="fab fa-aws"></i>
                                        <span className="ml-1">{this.props.t('AWS Scans')}</span>
                                    </Link>
                                    <ul className="sub-menu" aria-expanded="false">
                                        <li><Link to="/aws-scans">{this.props.t('Scan History')}</Link></li>
                                    </ul>
                                </li> 
                                : null
                            }

                           
                            {
                                userPerms.indexOf(3) !== -1  || localStorage.getItem("user_type") === 'admin' ?
                            <li>
                                <Link to="/#" className="has-arrow waves-effect">
                                    <i className="fab fa-microsoft"></i>
                                    <span className="ml-1">{this.props.t('Azure Scans')}</span>
                                </Link>
                                <ul className="sub-menu" aria-expanded="false">
                                    <li><Link to="/azure-scans">{this.props.t('Scan History')}</Link></li>
                                </ul>
                            </li>  
                               : null
                            }

                                                
                            
                            {
                                userPerms.indexOf(2) !== -1 || localStorage.getItem("user_type") === 'admin' ? 
                                <li>
                                    <Link to="/#" className="has-arrow waves-effect">
                                        <i className="fab fa-google"></i>
                                        <span className="ml-1">{this.props.t('GCP Scans')}</span>
                                    </Link>
                                    <ul className="sub-menu" aria-expanded="false">
                                        <li><Link to="/gcp-scans">{this.props.t('Scan History')}</Link></li>
                                    </ul>
                                </li>  : null
                            }
                            
                            
                            {
                                userPerms.indexOf(4) !== -1 || localStorage.getItem("user_type") === 'admin' ? 
                                <li>
                                    <Link to="/#" className="has-arrow waves-effect">
                                        <i className="fa fa-cloud"></i>
                                        <span className="ml-1">{this.props.t('Oracle Cloud Scans')}</span>
                                    </Link>
                                    <ul className="sub-menu" aria-expanded="false">
                                        <li><Link to="/oracle-cloud-scans">{this.props.t('Scan History')}</Link></li>
                                    </ul>
                                </li>
                                : null
                            }                     
                           
                           
                            <li>
                                <Link to="/settings" className="waves-effect">
                                    <i className="fa fa-key"></i>
                                    <span className="badge badge-pill badge-success float-right"></span>
                                    <span className="ml-1">{this.props.t('Cloud API Keys')}</span>
                                </Link>
                            </li>                                  
                            
                            <li style={{display:'none'}}>
                                <Link to="/#" className="has-arrow waves-effect">
                                    <i className="ri-store-2-line"></i>
                                    <span className="ml-1">{this.props.t('Container Vulnerability')}</span>
                                </Link>
                                <ul className="sub-menu" aria-expanded="false">
                                    <li><Link to="/kubernetes-vulnerability-management">{this.props.t('Kubernetes')}</Link></li>
                                    <li><Link to="/docker-vulnerability-management">{this.props.t('Docker')}</Link></li>
                                </ul>
                            </li>  

                            <li style={{display:'none'}}>
                                <Link to="/anomaly-detection" className="waves-effect">
                                    <i className="ri-store-2-line"></i>
                                    <span className="ml-1">{this.props.t('Anomaly Detection')}</span>
                                </Link>
                            </li>  


                            {
                                userPerms.indexOf(4) !== -1 || localStorage.getItem("user_type") === 'admin' ? 
                                <li style={{display:'none'}}>
                                    <Link to="/#" className="has-arrow waves-effect">
                                        <i className="ri-store-2-line"></i>
                                        <span className="ml-1">{this.props.t('Help')}</span>
                                    </Link>
                                    <ul className="sub-menu" aria-expanded="false">
                                        <li><Link to="/anomaly-detection-agent-installation-guide">{this.props.t('Anomaly Detection Agent Installtion Guide')}</Link></li>
                                    </ul>
                                </li>
                                : null
                            }     

                            {
                                userPerms.indexOf(4) !== -1 || localStorage.getItem("user_type") === 'admin' ? 
                                 <li style={{display:'none'}}>
                                    <Link to="/notifications" className="waves-effect">
                                        <i className="ri-store-2-line"></i>
                                        <span className="ml-1">{this.props.t('Notifications')}</span>
                                    </Link>
                                </li>  
                                : null
                            }     

                            <li style={{display:'none'}}>
                                <Link to="/result-integrations" className="waves-effect">
                                    <i className="ri-dashboard-line"></i><span className="badge badge-pill badge-success float-right"></span>
                                    <span className="ml-1">{this.props.t('Result Integrations')}</span>
                                </Link>
                            </li>  


                        </ul>
                    </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    return { ...state.Layout };
  };

export default withRouter(connect(mapStatetoProps, {
    changeLayout,
    changeSidebarTheme,
    changeSidebarType,
    changeLayoutWidth,
    changePreloader
})(withNamespaces()(SidebarContent)));
